import React from "react";
// import React, { useState, useEffect } from 'react';

const Header = (props) => {
  return <h1>{props.title}</h1>;
};

export default Header;
